// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"105":"entity","966":"dashboard"}[chunkId] + "." + {"105":"81a8c397","966":"ee0276e2"}[chunkId] + ".chunk.css";
};